const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12Zm-4.74-7.46v-8A1.5 1.5 0 0 1 8.76 7h.48a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-.48a1.5 1.5 0 0 1-1.5-1.46Zm6-8A1.5 1.5 0 0 1 14.71 7h.53a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-.53a1.5 1.5 0 0 1-1.5-1.5Z" fill="currentColor"></path></svg>';
export {
  t as default
};
